// NOTE: this file was auto-generated with `libraries/icons/src/_private/transform.ts`
// Any manual edits will be overwritten via `rush build`

import { SVGProps } from 'react';

const FaceMouthSmallFilled = (props: SVGProps<SVGSVGElement>) => (
	<svg width="1em" height="1em" viewBox="0 0 96 96" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
		<path
			fillRule="evenodd"
			clipRule="evenodd"
			d="M8.5 48C8.5 26.22 26.22 8.5 48 8.5S87.5 26.22 87.5 48 69.78 87.499 48 87.499s-39.5-17.72-39.5-39.5Zm32.269-12.76c0 2.583-1.371 4.677-3.062 4.677-1.69 0-3.061-2.094-3.061-4.678s1.371-4.679 3.061-4.679c1.691 0 3.062 2.095 3.062 4.68Zm17.487 4.677c1.69 0 3.062-2.094 3.062-4.678s-1.371-4.679-3.062-4.679c-1.69 0-3.061 2.095-3.061 4.68 0 2.583 1.37 4.677 3.06 4.677Zm1.2 16.465a2 2 0 0 1 3.59 1.764c-2.772 5.644-8.68 9.292-15.046 9.292-6.417 0-12.343-3.689-15.097-9.397a1.998 1.998 0 1 1 3.6-1.738c2.094 4.334 6.606 7.135 11.497 7.135 4.854 0 9.35-2.77 11.457-7.056Z"
			fill="#fff"
		/>
	</svg>
);
export default FaceMouthSmallFilled;
